import { jsx as _jsx } from "react/jsx-runtime";
import { useBreakpointsContext } from "@air/provider-media-query";
import { useMemo } from "react";
import { GalleryItemType } from "~/components/Gallery/types";
import { PublicAssetTableRow } from "~/components/TableView/PublicTableView/PublicAssetTableRow";
import { PublicBoardTableRow } from "~/components/TableView/PublicTableView/PublicBoardTableRow";
import { getLoaderRow, MOBILE_TABLE_ROW_HEIGHT, TABLE_ROW_HEIGHT } from "~/components/TableView/tableRowUtils";
import { useWorkspaceHorizontalPadding } from "~/hooks/useWorkspaceHorizontalPadding";
import { getAssetGalleryItemType } from "~/utils/AssetUtils";
export const usePublicTableRows = (param)=>{
    let { data, hasMore, isLoading, isLoadingMore, loadMore, isBoardSelectable, isAssetSelectable } = param;
    const { isAboveMediumScreen } = useBreakpointsContext();
    const { responsiveHorizontalPadding } = useWorkspaceHorizontalPadding();
    const rows = useMemo(()=>{
        const tableRows = [];
        data.forEach((rowData)=>{
            switch(rowData.type){
                case "board":
                    tableRows.push({
                        height: !isAboveMediumScreen ? MOBILE_TABLE_ROW_HEIGHT : TABLE_ROW_HEIGHT,
                        getMetadata: ()=>({
                                isSelectable: isBoardSelectable,
                                item: rowData.item,
                                type: GalleryItemType.board
                            }),
                        // eslint-disable-next-line react/display-name
                        render: (rowStyle, key)=>/*#__PURE__*/ _jsx(PublicBoardTableRow, {
                                data: rowData.item,
                                style: {
                                    paddingLeft: responsiveHorizontalPadding,
                                    paddingRight: responsiveHorizontalPadding,
                                    ...rowStyle
                                }
                            }, key)
                    });
                    break;
                case "asset":
                case "file":
                    tableRows.push({
                        height: !isAboveMediumScreen ? MOBILE_TABLE_ROW_HEIGHT : TABLE_ROW_HEIGHT,
                        getMetadata: ()=>({
                                isSelectable: isAssetSelectable,
                                item: rowData.item,
                                type: getAssetGalleryItemType(rowData.item)
                            }),
                        // eslint-disable-next-line react/display-name
                        render: (rowStyle, key)=>/*#__PURE__*/ _jsx(PublicAssetTableRow, {
                                data: rowData.item,
                                style: rowStyle
                            }, key)
                    });
                    break;
            }
        });
        if (hasMore || isLoading || isLoadingMore) {
            tableRows.push(getLoaderRow(isLoading, loadMore));
        }
        return tableRows;
    }, [
        data,
        hasMore,
        isLoading,
        isLoadingMore,
        isAboveMediumScreen,
        isBoardSelectable,
        responsiveHorizontalPadding,
        isAssetSelectable,
        loadMore
    ]);
    return rows;
};
